<template>
    <v-container
      id="editUserProfile"
      class="fill-height justify-center"
      tag="section"
    >
      <v-card id="accountSelection" width="400">
        <v-card-title class="text-center">
{{ $t('editProfile.edit-details') }}
</v-card-title>
        <v-card-text>
        <div>
          <v-list>
         <!-- <v-list-item class="pa-0">
            <v-btn color="blue" block @click="editPhoneNumber">
{{ $t('editProfile.change-phone-number') }}
</v-btn>
          </v-list-item> -->
          <v-list-item class="pa-0">
            <v-btn color="blue" block @click="changePassword">
{{ $t('editProfile.change-password') }}
</v-btn>
          </v-list-item>
          <v-list-item class="pa-0">
            <v-btn color="primary" block @click="returnHome">
{{ $t('editProfile.return-home') }}
</v-btn>
          </v-list-item>
        </v-list>
        </div>
        </v-card-text>
      </v-card>
      <v-dialog v-model="showEditPhoneNumberDialog" max-width="500px">
          <v-card>
            <v-card-title>{{ $t('editProfile.change-phone-number') }}<br></v-card-title>
            <v-card-text>
            <v-overlay class="waitoverlay" :value="loading">
          <v-progress-circular
            indeterminate
            size="64"
            class="mr-4"
          /> {{ waitMessage }}
         </v-overlay>
        <v-form
          ref="form"
          v-model="valid"
        >
        <div>
          <p v-show="checkPhoneValidation(phoneLength, phoneNumber, phoneHasNum, sub)">
            {{ $t('editProfile.phone-number') }}
            <i class="fa fa-exclamation-circle tooltip error">
              <span>
                {{ $t('editProfile.phone-number-must-have-at-least-11-numbers-and-have-no-letters-parenthis-or-dashes') }}
              </span>
            </i>
          </p>
          <v-text-field
            id="phoneNumber"
            v-model="phoneNumber"
            required
            :rules="[rules.required, rules.minPhoneNumber]"
            :placeholder="$t('editProfile.phone-number-44-1234-987654')"
            @focus="showphonenumberrequirements"
            @input="removeNonDigitCharacters"
          />
          <ul v-show="disphoner === true">
            <li v-show="phoneLength === false">
              {{ $t('editProfile.phone-number-must-be-11-numbers-long') }}
            </li>
            <li v-show="phoneHasNum === false || phoneNumber === ''">
              {{ $t('editProfile.phone-number-must-contain-only-numbers') }}
            </li>
          </ul>
        </div>
        </v-form>
      <div v-if="error" class="phonenumbererror">
            {{ error }}<br>
          </div>
        </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="closePhoneNumberDialog">
{{ $t('global.cancel') }}
</v-btn>
              <v-btn :disabled="!valid" color="red" @click="changePhoneNumber">
{{ $t('editProfile.update') }}
</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showChangePasswordDialog" max-width="500px">
          <v-card>
            <v-card-title>{{ $t('editProfile.change-password') }}<br></v-card-title>
            <v-card-text>
                <v-overlay class="waitoverlay" :value="loading">
                <v-progress-circular
                    indeterminate
                    size="64"
                    class="mr-4"
                /> {{ waitMessage }}
                </v-overlay>
                <v-form
                ref="form"
                v-model="validPassword"
                >
                 <p>{{ $t('editProfile.change-password-instructions') }}</p>
                 <password-set-fields @password-change="updatePassword" />
</v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn @click="closeChangePasswordDialog">
{{ $t('global.cancel') }}
</v-btn>
              <v-btn color="red" :disabled="!validPassword" @click="changePasswordSumbit">
Update
</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :timeout="5000"
            >
{{ $t('editProfile.phone-number-updated') }}
</v-snackbar>
    </v-container>
  </template>

<script>
  import zxcvbn from 'zxcvbn'
  import api from '@/helpers/api.js'
  import 'firebase/auth'
  import router from '@/router'
  import firebase from 'firebase/app'
  import PasswordsetFields from '../components/PasswordSetFields.vue'
  import { cookies } from '@/util/cookies.js'

  export default {

    components: {
      'password-set-fields': PasswordsetFields,
    },

    data: function () {
      return {
        error: '',
        showEditPhoneNumberDialog: false,
        showChangePasswordDialog: false,
        phoneNumber: '',
        sub: 0,
        disphoner: false,
        password: '',
        displayName: '',
        confirmPassword: '',
        valid: false,
        validPassword: false,
        loading: false,
        snackbar: false,
        timeout: 4000,
        show: false,
        waitMessage: 'Updating...',

        rules: {
          minPhoneNumber: v => v.length >= 11,
          required: value => !!value || this.$t('editProfile.required'),
          min: v => v.length >= 8 || this.$t('register.min-characters'),
          match: value => value === this.password || this.$t('register.does-not-match'),
          passwordStrength: value => {
            const passwordAnalysis = zxcvbn(value)
            return passwordAnalysis.score > 2 || this.$t('register.password-is-weak')
          },
          password: value => {
            const pattern = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})')
            return pattern.test(value) || this.$t('register.min-password-security')
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('register.invalid-e-mail')
          },
        },
      }
    },
    computed: {
      phoneHasNum () {
        this.phoneNumber.replace('(', '')
        this.phoneNumber.replace(')', '')
        this.phoneNumber.replace('-', '')
        if (isNaN(this.phoneNumber)) {
          return false
        } else {
          return true
        }
      },
      phoneLength () {
        if (this.phoneNumber.trim().length >= 11) {
          return true
        } else {
          return false
        }
      },
      passwordsMatch () {
        return () => (this.password === this.confirmPassword) || this.$t('register.password-must-match')
      },
    },
    methods: {
      updatePassword (newPassword) {
        this.password = newPassword
      },
      editPhoneNumber () {
        this.showEditPhoneNumberDialog = true
      },
      changePassword () {
        this.showChangePasswordDialog = true
      },
      async changePhoneNumber () {
        this.loading = true
        const authUserId = this.$store.getters.getAuthUserId
        const currentUserID = cookies.get('currentUserID')
        try {
          await api.updateUserPhoneNumberOrPassword(currentUserID, { phoneNumber: this.phoneNumber, uuid: authUserId })
          this.snackbar = true
        } catch (e) {
          console.log(e)
          this.error = e.message
        }
        this.showEditPhoneNumberDialog = false
        this.loading = false
      },
      returnHome () {
        // router.push({ path: '/selectProfile' })
        router.back()
      },
      closePhoneNumberDialog () {
        this.phoneNumber = ''
        this.showEditPhoneNumberDialog = false
      },
      closeChangePasswordDialog () {
        this.showChangePasswordDialog = false
      },
      async changePasswordSumbit () {
        try {
          this.loading = true
          const authUserId = this.$store.getters.getAuthUserId
          const currentUserID = cookies.get('currentUserID')
          await api.updateUserPhoneNumberOrPassword(currentUserID, { password: this.password, uuid: authUserId })
          this.snackbar = true
          this.showChangePasswordDialog = false
          this.$store.commit('SET_USER_PROFILES', null)
          this.$store.commit('SET_CONTENT_LIBRARY', null)
          await firebase.auth().signOut()
          router.push('/login')
          this.loading = false
        } catch (e) {
          console.log(e)
          this.error = e.message
        }
      },
      removeNonDigitCharacters () {
        this.phoneNumber = this.phoneNumber.replace(/[^0-9]+/s, '')
      },
      showphonenumberrequirements () {
        this.sub = 0
        this.disphoner = true
      },
      checkPhoneValidation: (phoneLength, phoneNumber, phoneHasNum, sub) => (phoneLength === false) &&
        (phoneNumber !== '' || phoneHasNum === false) &&
        (phoneNumber !== '' || phoneNumber === '') &&
        (sub === 1),
    },
  }
</script>
<style scoped>

.phonenumbererror {
  background: transparent;
  color: red;
  font-weight: bold;
}
</style>
